import { CellType, ExcelColorValue, UploadStatus, Constants } from "../../util/UIConstants";
import { IColumnConfig } from "../configuration";
import { labels, currentResource } from "../../util/utils";
import Utility from "../../util/utilityFunctions";

export class MisstatementConfiguration implements IColumnConfig {
  rowheader: any[];
  columns: any[];

  constructor() {
    this.columns = [
      {
        CellHeader: labels.status,
        CellId: "UploadStatus",
        CellFormat: {
          locked: true,
          HeaderFillColor: ExcelColorValue.Black,
          RowsFillColor: ExcelColorValue.GrayColor,
        },
        getCellData: (data) => {
          return `${currentResource.uploadStatusLabels[UploadStatus.Downloaded]}`;
        },
      },
      {
        CellHeader: labels.updateCanvas,
        IsMarkValue: true, // This can be only one
        CellId: "MarkForUpdate",
        CellFormat: {
          locked: false,
          RowsFillColor: ExcelColorValue.White,
        },
        getCellData: (data) => {
          return Constants.MarkForUpdateNo;
        },
        referenceData: {
          getCellData: (userLanguage) => {
            return Utility.updateEYCanvasDropDownValues;
          },
        },
        cellToBindDropDown: true,
      },
      {
        CellHeader: labels.misstatementIndex,
        CellId: "MisstatementIndex",
        CellFormat: {
          requiredColumnWidth: 168.66,
          locked: false,
          RowsFillColor: ExcelColorValue.White,
          horizontalAlignment: "Left",
          disableDefaultFormatting: true,
          wrapText: true,
        },
        getCellData: (data) => {
          return data.misstatementIndex;
        },
      },
      {
        CellHeader: labels.misstatementDescription,
        CellId: "MisstatementDescription",
        CellFormat: {
          locked: false,
          requiredColumnWidth: 278.27,
          RowsFillColor: ExcelColorValue.White,
          horizontalAlignment: "Left",
          wrapText: true,
        },
        getCellData: (data) => {
          return data.description;
        },
      },
      {
        CellHeader: labels.misstatementIndex + " ",
        CellId: "OriginalMisstatementIndex",
        CellFormat: {
          requiredColumnWidth: 168.66,
          locked: true,
          HeaderFillColor: ExcelColorValue.Black,
          RowsFillColor: ExcelColorValue.GrayColor,
          horizontalAlignment: "Left",
          disableDefaultFormatting: true,
          wrapText: true,
        },
        getCellData: (data) => {
          return data.misstatementIndex;
        },
      },
      {
        CellHeader: labels.misstatementDescription + " ",
        CellId: "OriginalMisstatementDescription",
        CellFormat: {
          locked: true,
          requiredColumnWidth: 278.27,
          HeaderFillColor: ExcelColorValue.Black,
          RowsFillColor: ExcelColorValue.GrayColor,
          horizontalAlignment: "Left",
          wrapText: true,
        },
        getCellData: (data) => {
          return data.description;
        },
      },
      {
        CellHeader: labels.misstatementId,
        CellId: "misstatementId",
        CellFormat: {
          locked: true,
          HeaderFillColor: ExcelColorValue.Black,
          RowsFillColor: ExcelColorValue.GrayColor,
          columnHidden: true,
        },
        getCellData: (data) => {
          return data.misstatementId;
        },
      },
      {
        CellHeader: labels.hash,
        CellId: "HashValue",
        HashAttribue: {
          HashCalculatedDataattributesName: [
            {
              CellId: "MisstatementIndex",
            },
            {
              CellId: "MisstatementDescription",
            },
          ],
        },
        CellFormat: {
          locked: true,
          HeaderFillColor: ExcelColorValue.Black,
          RowsFillColor: ExcelColorValue.GrayColor,
          columnHidden: true,
        },
        getCellData: (data) => {
          let hashValue: string = "";
          hashValue = Utility.getHashValueForRow(this.columns, [], data); // can be more then one
          return hashValue;
        },
      },
      {
        CellHeader: labels.statusId,
        CellType: CellType.DynamicCell,
        CellId: "UploadStatusId",
        CellFormat: {
          locked: true,
          HeaderFillColor: ExcelColorValue.Black,
          RowsFillColor: ExcelColorValue.GrayColor,
          columnHidden: true,
        },
        getCellData: (data) => {
          return `${UploadStatus.Downloaded}`;
        },
      },
    ];
    this.rowheader = [
      {
        CellHeader: labels.referenceOnly,
        DisplayRange: ["A1:A1", "E1:I1"],
        CellFormat: {
          locked: true,
        },
      },
      {
        CellHeader: labels.columnsToUpdate,
        DisplayRange: ["B1:D1"],
        CellFormat: {
          locked: true,
          HeaderFillColor: ExcelColorValue.GrayColor,
        },
      },
    ];
  }
}
